// import RepositoryFactory from "@/apis";
// const whatsapp = RepositoryFactory.whatsapp;
import whatsapp from "../../apis/whatsapp";

export default {
  getUserInfo({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await whatsapp.getUserInfo(payload);
        // console.log(data);
        // console.log(data.data);
        resolve(data.data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
